import React, { Component, PropTypes } from 'react';
import FriendList from './FriendList.js';
import './FilterableFriendList.css';

class FilterableFriendList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filter: ''
    };

    this.handleInput = this.handleInput.bind(this);
  }

  handleInput(ev) {
    const { target } = ev;
    this.setState({ filter: target.value });
  }

  render() {
    const { className, allowDragging, users } = this.props;
    const { filter } = this.state;

    const filteredUsers = users.filter((u) => {
      let displayName = (u.displayName && u.displayName.toLowerCase()) || '';
      return displayName.includes(filter);
    });

    let listClassNames = ['FilterableFriendList'];
    if (className) {
      listClassNames.push(className);
    }

    return (
      <div className={listClassNames.join(' ')}>
        <input type="text" className="FilterableFriendList__input" placeholder="Type here to filter..." onChange={this.handleInput} value={filter} />
        <FriendList allowDragging={allowDragging} users={filteredUsers} />
      </div>
    );
  }
};

FilterableFriendList.propTypes = {
  allowDragging: PropTypes.bool,
  users: PropTypes.arrayOf(PropTypes.object)
};

export default FilterableFriendList;



// WEBPACK FOOTER //
// ./src/components/FilterableFriendList.js